var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import styled from 'react-emotion';
const BaseButton = styled('button') `
  cursor: pointer;
  display: flex;
  align-items: center;
  outline: none;
  border: none;
`;
export const Button = (_a) => {
    var { as: Component = BaseButton } = _a, props = __rest(_a, ["as"]);
    return React.createElement(Component, Object.assign({}, props));
};
export const ButtonLink = styled(Button) `
  background: transparent;
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQnV0dG9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2NvbXBvbmVudHMvdWkvQnV0dG9uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSxPQUFPLEtBQUssS0FBSyxNQUFNLE9BQU8sQ0FBQTtBQUU5QixPQUFPLE1BQU0sTUFBTSxlQUFlLENBQUE7QUFFbEMsTUFBTSxVQUFVLEdBQUcsTUFBTSxDQUFDLFFBQVEsQ0FBQyxDQUFBOzs7Ozs7Q0FNbEMsQ0FBQTtBQU1ELE1BQU0sQ0FBQyxNQUFNLE1BQU0sR0FBcUIsQ0FBQyxFQUd4QyxFQUFFLEVBQUU7UUFIb0MsRUFDdkMsRUFBRSxFQUFFLFNBQVMsR0FBRyxVQUFVLE9BRTNCLEVBREMsMEJBQVE7SUFDSixPQUFBLG9CQUFDLFNBQVMsb0JBQUssS0FBSyxFQUFJLENBQUE7Q0FBQSxDQUFBO0FBRTlCLE1BQU0sQ0FBQyxNQUFNLFVBQVUsR0FBRyxNQUFNLENBQUMsTUFBTSxDQUFDLENBQUE7O0NBRXZDLENBQUEifQ==